import { FC, PropsWithChildren } from "react";

import { useTranslation } from "react-i18next";

import { Alert } from "@mui/material";
import { ErrorBoundary as ErrorBoundaryComponent } from "react-error-boundary";

const ErrorBoundary: FC<PropsWithChildren<{ hideErrorMessage?: boolean }>> = ({
  children,
  hideErrorMessage = false,
}) => {
  const { t } = useTranslation();

  return (
    <ErrorBoundaryComponent
      fallback={hideErrorMessage ? null : <Alert severity="error">{t("global.errors.genericError")}</Alert>}
    >
      {children}
    </ErrorBoundaryComponent>
  );
};

export default ErrorBoundary;
